import AboutShow from "../components/about/Show";

export default [
  { name: 'About', path: '/about', component: AboutShow, meta: {  showHeaderBanner: true }}
]
